import React from 'react';
import PropTypes from 'prop-types';

import { ReadingGraphs } from './ReadingGraphs';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const Charts = ({ dataObject, isFetching }) => {
  const { dataSet, readingTypes, graphDomain } = dataObject();
  const { t } = useTranslation();
  if (isFetching === true) {
    return (
      <Grid item>
        <CircularProgress /> Loading...
      </Grid>
    );
  }
  return (
    <>
      {dataSet && dataSet.length > 0 && (
        <ReadingGraphs dataSet={dataSet} readingTypes={readingTypes} graphDomain={graphDomain} />
      )}
      {!dataSet || (dataSet.length === 0 && <Typography>{t('no_telemetry_chart')} </Typography>)}
    </>
  );
};

Charts.propTypes = {
  dataObject: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

Charts.defaultProps = {};

export default Charts;
